import { render, staticRenderFns } from "./CustomerSidebar.vue?vue&type=template&id=a99db13a&scoped=true&"
import script from "./CustomerSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSidebar.vue?vue&type=style&index=0&id=a99db13a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99db13a",
  null
  
)

export default component.exports